import { type ReactNode } from 'react';
import { Provider } from 'react-aria-components';
import {
  ButtonContext,
  ButtonGroupContext,
  ComboBoxContext,
  InputContext,
  LinkContext,
  SelectContext,
  SwitchContext,
} from '@launchpad-ui/components';

type RestrictProviderProps = {
  isDisabled: boolean;
  children: ReactNode;
};

export function RestrictProvider({ isDisabled, children }: RestrictProviderProps) {
  return (
    <Provider
      values={[
        [ButtonContext, { isDisabled }],
        [LinkContext, { isDisabled }],
        [ComboBoxContext, { isDisabled }],
        [SelectContext, { isDisabled }],
        [InputContext, { disabled: isDisabled }],
        [SwitchContext, { isDisabled }],
        [ButtonGroupContext, { isDisabled }],
      ]}
    >
      {children}
    </Provider>
  );
}
